import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

import { ID_CODE_MAX_LENGTH } from 'app/constants';

@Directive({
    selector: 'input[stbyIdCodeInput]',
})
export class IdCodeInputDirective {
    private readonly el = inject<ElementRef<HTMLInputElement>>(ElementRef);
    private readonly ngControl = inject(NgControl, { optional: true });

    constructor() {
        this.el.nativeElement.inputMode = 'numeric';
        this.el.nativeElement.maxLength = ID_CODE_MAX_LENGTH;
    }

    @HostListener('input')
    onInput(): void {
        const input = this.el.nativeElement;
        const sanitized = input.value.replace(/[^0-9]/g, '').slice(0, ID_CODE_MAX_LENGTH);
        if (sanitized === input.value) return;

        input.value = sanitized;
        this.ngControl?.control?.setValue(sanitized, { emitEvent: true });
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent): void {
        if (isAllowedKey(event)) return;
        if (/^\d$/.test(event.key)) return;
        event.preventDefault();
    }
}

function isAllowedKey(event: KeyboardEvent): boolean {
    const navigationKeys = ['ArrowLeft', 'ArrowRight', 'Backspace', 'Delete', 'Tab', 'Home', 'End', 'Enter'];
    if (navigationKeys.includes(event.key)) return true;
    const isCtrlOrCmd = event.ctrlKey || event.metaKey;
    return isCtrlOrCmd && ['a', 'c', 'v', 'x', 'z'].includes(event.key.toLowerCase());
}
